import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
// modules
import configModule from "./modules/config";
import adminModule from "./modules/admin";
import masterModule from "./modules/master";
import sourceModule from "./modules/source";
import extractionModule from "./modules/extraction";
import chemModule from "./modules/chem";
import chemFamilyModule from "./modules/chemFamily";
import chemFunctionModule from "./modules/chemFunction";
import userModule from "./modules/user";
import projectModule from "./modules/project";
import processModule from "./modules/process";
import mappingModule from "./modules/mapping";

// https://stackoverflow.com/questions/41572974/how-to-load-all-server-side-data-on-initial-vue-js-vue-router-load
const mainStore = new Vuex.Store({
  modules: {
    config: configModule,
    admin: adminModule,
    user: userModule,
    project: projectModule,
    master: masterModule,
    source: sourceModule,
    extraction: extractionModule,
    chem: chemModule,
    chemFamily: chemFamilyModule,
    chemFunction: chemFunctionModule,
    process: processModule,
    mapping: mappingModule
  },
  state: {
    loading: true // global,
  },
  mutations: {
    setLoading(state, newLoading) {
      state.loading = newLoading;
    }
  },
  actions: {

  },
  getters: {
    loading: state => {
      return state.loading;
    }
  }
});

export default mainStore;
